import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import OverflowTooltip from '../../../common/OverflowTooltip/OverflowTooltip';
import { generateImageSource } from '../../../../utils/generateImageSource';

const urlValidation = (companyUrl) => {
  let pattern = new RegExp(
    // protocol
    '^(https?:\\/\\/)?'
    // domain name
    + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'
    // OR ip (v4) address
    + '((\\d{1,3}\\.){3}\\d{1,3}))'
    // port and path
    + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'
    // query string
    + '(\\?[;&a-z\\d%_.~+=-]*)?'
    // fragment locator
    + '(\\#[-a-z\\d_]*)?$', 'i');
  return !!pattern.test(companyUrl);
};

const CompanyDetailsTip = ({ jobPosting }) => {
  if (jobPosting?.companyName
    || jobPosting?.companyUrl) {
    return (
      <div className="create-job-posting__tooltip-section" data-testid="pro-tip-company-details">
        <div className="create-job-posting__tip-label">
          <p>
            <Image
              src={generateImageSource('/images/v1/path-to-pro/tradeTypes/nonResidentialConstruction.svg')}
              className="create-job-posting__tip-icon"
              alt="trade icon"
              data-testid="tradeTypeIcon"
            />
            Your Company
          </p>
        </div>
        <p>{jobPosting?.companyName}</p>
        {urlValidation(jobPosting?.companyUrl)
          && (
            <OverflowTooltip
              className="ptp-common__hyperlink"
              data-testid="job-posting-static-companyUrl"
            >
              <a
                href={jobPosting?.companyUrl}
                style={{ fontWeight: '700' }}
                className="ptp-common__hyperlink"
                data-testid="job-posting-static-companyUrl"
              >
                {jobPosting?.companyUrl}
              </a>
            </OverflowTooltip>
          )}
      </div>
    );
  }
  return null;

};

export default CompanyDetailsTip;